import React, { Component } from "react";
import { Field, FieldArray, reduxForm } from "redux-form";
import Option from "muicss/lib/react/option";
import { renderField } from "utils/forms";
import { connect } from "react-redux";
import { actions } from "actions/resources";
import Multiselect from "react-widgets/lib/Multiselect";
import "react-widgets/dist/css/react-widgets.css";
import S from "string";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
//antd
import {
  AutoComplete,
  Button,
  Col,
  Icon,
  Modal,
  Row,
  Select,
  Alert,
  Slider
} from "antd";
//components

import ProfilePicture from "@dsalvagni/react-profile-picture";
import "@dsalvagni/react-profile-picture/build/ProfilePicture.css";

import { bindActionCreators } from "redux";

import ProgressiveImage from "react-progressive-image";

import defaultStakeholderImage from "images/default_profile.jpg";


const fields = ["name", "functional_areas", "prize_type", "status"];

const validate = values => {
  const errors = {};

  fields.forEach(field => {

    if (!values[field]) {
      errors[field] = `${S(field).humanize().s} required`;
    }

    if (values.start_date > values.end_date) {
      errors["start_date"] = "Start date should not be greater than End Date ";
    }

    if (values.status === "active" || values.status === "in_progress") {
      if (!values.typeform_form_id) {
        if (typeof values.is_tbd === "undefined" || values.is_tbd === false) {
          errors["typeform_form_id"] = "Please add typeForm id for this challenge";
        }
      }
    }

    if (values.company_id === "undefined") {
      errors["company_id"] =
        "Company Name is not from the list. Please search and select form dropdown.";
    }
    if (!values.company_id) {
      errors["company_id"] =
        "Company Name is not from the list. Please search and select form dropdown";
    }
  });
  return errors;
};

const timeCommitmentOptions = Array.from(Array(101).keys()).map(
  (integer, i) => {
    return {
      value: integer.toString(),
      label: `${integer} Hours`
    };
  }
);

const numberOfTeamsOptions = Array.from(Array(101).keys()).map((integer, i) => {
  return {
    value: integer,
    label: `${integer} Team(s)`
  };
});

const functional_areas = [
  "Accounting",
  "Analytics",
  "Consulting",
  "Engineering/Technology",
  "Entreprenuership/Venture Management",
  "Finance",
  "General Managment",
  "HR/Human Capital",
  "Marketing",
  "Operations/ Supply eChain",
  "Social Impact",
  "Strategy"
];

const toolBarOptions = {
  options: ['inline',
    'blockType',
    // 'fontSize',
    'list',
    'textAlign',
    'link',
    // 'embedded',
    // 'emoji',
    // 'image',
    'remove',
    'history'],
  inline: { inDropdown: true },
  list: { inDropdown: true },
  textAlign: { inDropdown: true },
  link: { inDropdown: false },
  history: { inDropdown: true }
};

const skillsList = [
  "Accounting",
  "Advertising",
  "Business Development",
  "Copy Writing",
  "Creative Writing",
  "Consulting",
  "Customer Service",
  "Data Analysis",
  "Economics",
  "Finance",
  "Graphic Design",
  "Human Resources",
  "Legal",
  "Marketing",
  "Negotiations",
  "Non-Profit",
  "Operations",
  "Product Management",
  "Public Relations",
  "Sales",
  "SEO / SEM Marketing",
  "Social Media",
  "Software Development",
  "Strategy",
  "Adaptability",
  "Effective Communication",
  "Conflict Resolution",
  "Decision Making",
  "Leadership",
  "Presentation Creation",
  "Public Speaking",
  "Time Management"
];

const skills = skillsList.map(skill => {
  return {
    label: skill,
    value: skill
  };
});

const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Created", value: "created" },
  { label: "Draft", value: "draft" },
  { label: "In-Progress", value: "in_progress" },
  { label: "Completed", value: "completed" }
];

// const teamSizeOptions = [
//   { label: "1-2", value: "1-2" },
//   { label: "2-3", value: "2-3" },
//   { label: "3-4", value: "3-4" },
//   { label: "4-5", value: "4-5" }
// ];

const travelRequirementOptions = [
  { label: "Some", value: "Some" },
  { label: "None", value: "None" },
  { label: "Alot", value: "Alot" }
];


class renderRangeField extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {

  }

  onChange = value => {
    let newValue = `${value[0]}-${value[1]}`;
    this.props.input.onChange(newValue);
  };

  render() {
    const sliderValues = this.props.input.value.split("-");
    let sliderValue = [1, 2];
    if (sliderValues.length === 2) {
      sliderValue = [];
      sliderValues.forEach(value => {
        sliderValue.push(Number(value));
      });
    }
    return (
      <div className="form-select-wrapper">
        <div >
          <label htmlFor="team_size">Team Size</label>
          <div style={{ height: 10 }} />
        </div>
        <Field
          name="team_size"
          component={renderField}
          type="text"
        />
        <Slider range value={sliderValue} min={1} max={10} onChange={this.onChange} />
      </div>
    )
  }
}


const renderSelectField = ({
  input,
  label,
  name,
  options,
  meta: { touched, error }
}) => {
  return (
    <div className="form-select-wrapper">
      {label ? (
        <div>
          <label htmlFor={name}>{label}</label>
          <div style={{ height: 10 }} />
        </div>
      ) : null}
      <Select {...input} label={label} onChange={input.onChange}>
        {options.map((option, i) => {
          return (
            <Option key={i} value={option.value}>
              {option.label}
            </Option>
          );
        })}
      </Select>
      {touched && error ? (
        <div style={{ color: "red" }}>{error}</div>
      ) : (
        <div className="input-error-label">&nbsp;</div>
      )}
    </div>
  );
};

const renderFieldArraySelect = ({
  label,
  fields,
  options,
  placeholder,
  meta: { error }
}) => (
  <div>
    <Row
      style={{ color: "#3a6efb", cursor: "pointer" }}
      onClick={() => fields.push()}
    >
      <Icon
        style={{ color: "#3a6efb", marginRight: 5, marginBottom: 10 }}
        type="plus-circle-o"
      />
      Add another {label}
    </Row>
    <Row>
      <Col span={24}>
        {fields.map((fieldName, index) => (
          <Row key={index} type="flex" justify="space-between">
            <Col span={20}>
              <Field
                placeholder={placeholder}
                name={fieldName}
                component={renderSelectField}
                options={options}
              />
            </Col>
            <Col span={2}>
              <Icon
                style={{ color: "red" }}
                type="close"
                onClick={() => fields.remove(index)}
              />
            </Col>
          </Row>
        ))}
      </Col>
    </Row>
    {error && <li style={{ color: "red" }}>{error}</li>}
  </div>
);

const renderFieldArrayInput = ({
  label,
  fields,
  horizontal,
  placeholder,
  meta: { error }
}) => (
  <div>
    <Row
      style={{ color: "#3a6efb", cursor: "pointer" }}
      onClick={() => fields.push()}
    >
      <Icon
        style={{ color: "#3a6efb", marginRight: 5, marginBottom: 10 }}
        type="plus-circle-o"
      />
      Add another {label}
    </Row>
    <Row>
      {fields.map((fieldName, index) => (
        <Col span={horizontal ? 8 : 24} key={index}>
          <Row type="flex" justify="space-between">
            <Col span={20}>
              <Field
                placeholder={placeholder}
                name={fieldName}
                component={renderField}
                type="text"
              />
            </Col>
            <Col span={2}>
              <Icon
                style={{ color: "red" }}
                type="close"
                onClick={() => fields.remove(index)}
              />
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
    {error && <li style={{ color: "red" }}>{error}</li>}
  </div>
);


class renderDropzoneInput extends React.Component {

  state = {
    edit: false
  };

  constructor(props) {
    super(props);
    this.pictureRef = React.createRef();
  }


  componentDidMount() {
    // can use any refs here
    // if (this.props.input.value && this.props.input.value.length > 0 && this.pictureRef.current) {
    //   // console.log("IMAGE", this.pictureRef.current);
    //   setTimeout(() => {
    //     // this.pictureRef.current.setImage(this.props.input.value);
    //     this.pictureRef.current.setImage(defaultStakeholderImage);
    //   }, 1000);
    // }
  }

  onImageChange = () => {
    // console.log("IMAGE CHANGE");
    this.props.input.onChange(this.pictureRef.current.getImageAsDataUrl());
  }

  render() {

    let image = defaultStakeholderImage;
    if (this.props.input) {
      if (this.props.input.value && this.props.input.value.length > 0) {
        if (Array.isArray(this.props.input.value) && this.props.input.value[0].preview) {
          image = this.props.input.value[0].preview;
        } else {
          if (this.props.input.value.startsWith("https")) {
            image = this.props.input.value;
          }
        }
      }
    }

    return (
      <div>
        {this.state.edit ? (
          <div>
            <ProfilePicture
              ref={this.pictureRef}
              debug={false}
              minImageSize={250}
              maxImageSize={250}
              frameSize={250}
              frameFormat="circle"
              backgroundSize={200}
              showFrame={true}
              useHelper={true}
              cropSize={250}
              onImagePropertiesChange={this.onImageChange}
            />
            <div style={{ justifyContent: "flex-end" }}>
              <a title="Edit Image" role="button" onClick={() =>
                this.setState({
                  edit: false,
                })
              }
              >
                Cancel
              </a>
            </div>
          </div>
        ) : (
          <div>
            <ProgressiveImage src={image} placeholder={image}>
              {src => <img alt="" src={image} style={{ maxWidth: "250px", borderRadius: "50%" }} title="Edit Image" onClick={() =>
                this.setState({
                  edit: true
                })
              } />}
            </ProgressiveImage>
          </div>
        )}
      </div>
    )
  }
}

const renderStakeholders = ({ fields, meta: { touched, error } }) => (
  <div>
    <Row
      style={{ color: "#3a6efb", cursor: "pointer" }}
      onClick={() => fields.push()}
    >
      <Icon
        style={{ color: "#3a6efb", marginRight: 5, marginBottom: 10 }}
        type="plus-circle-o"
      />
      Add another stakeholder
    </Row>
    <Row type="flex" justify="space-around">
      {fields.map((stakeholder, index) => (
        <Col span={8} key={index}>
          <Row type="flex" justify="center">
            <Col span={20}>
              <Row type="flex" justify="end">
                <Icon
                  style={{ color: "red" }}
                  type="close"
                  onClick={() => fields.remove(index)}
                />
              </Row>
              <Row type="flex" justify="center" style={{ marginBottom: 20 }}>
                <Field
                  name={`${stakeholder}.image`}
                  component={renderDropzoneInput}
                />
              </Row>
              <Row>
                <Field
                  name={`${stakeholder}.given_name`}
                  type="text"
                  component={renderField}
                  placeholder="First Name"
                />
                <Field
                  name={`${stakeholder}.family_name`}
                  type="text"
                  component={renderField}
                  placeholder="Last Name"
                />
                <Field
                  name={`${stakeholder}.position`}
                  type="text"
                  component={renderField}
                  placeholder="Title"
                />
              </Row>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
    {error && <li style={{ color: "red" }}>{error}</li>}
  </div>
);

const renderCompanyField = ({
  input,
  meta: { touched, error, warning },
  options,
  companyName,
  searchCompanies
}) => {



  return (
    <div>
      <AutoComplete
        placeholder={companyName ? `${companyName}` : "Search Company By Name"}
        onSearch={value => searchCompanies(value)}
        onSelect={v => input.onChange(v)}
        dataSource={options.map(option => {
          return (
            <AutoComplete.Option key={option.name} value={option.objectID}>
              {option.name}
            </AutoComplete.Option>
          );
        })}
      />
      {touched && error ? (
        <div style={{ color: "red" }}>{error}</div>
      ) : (
        <div className="input-error-label">&nbsp;</div>
      )}
    </div>
  );
};

//const renderDatePicker = ({ input }) => {
//  return (
//    <div>
//      <DatePicker
//        onChange={v => input.onChange(v.format("M/YY"))}
//        format={"M/YY"}
//      />
//    </div>
//  );
//};

const renderDeliverablesTimeline = ({ fields, meta: { error } }) => (
  <div>
    <Row
      style={{ color: "#3a6efb", cursor: "pointer", marginBottom: 10 }}
      onClick={() => fields.push()}
    >
      <Icon style={{ color: "#3a6efb", marginRight: 5 }} type="plus-circle-o" />
      Add another date
    </Row>
    {fields.map((deliverable, i) => (
      <Row key={i} type="flex" justify="space-between">
        <Col span={11}>
          <Field
            name={`${deliverable}.name`}
            type="text"
            component={renderField}
            placeholder="Name of Deliverable"
          />
        </Col>
        <Col span={11}>
          <Field
            name={`${deliverable}.date`}
            type="date"
            component={renderField}
            placeholder="Deliverable Date"
          />
        </Col>
        <Icon
          style={{ color: "red" }}
          type="close"
          onClick={() => fields.remove(i)}
        />
      </Row>
    ))}
    {error && <li style={{ color: "red" }}>{error}</li>}
  </div>
);

const renderMultiselect = ({
  input,
  data,
  valueField,
  textField,
  meta: { touched, error }
}) => (
  <div>
    <Multiselect
      {...input}
      placeholder="Challenge Areas ( Select one or more )"
      onBlur={() => input.onBlur()}
      value={input.value || []}
      data={data}
      valueField={valueField}
      textField={textField}
    />
    {touched && error ? (
      <div style={{ color: "red" }}>{error}</div>
    ) : (
      <div className="input-error-label">&nbsp;</div>
    )}
  </div>
);

const RadioGroup = ({ input, meta: { error, touched }, options }) => {
  return (
    <Col span={20}>
      <Row type="flex" justify="space-between">
        {options.map(o => (
          <label key={o.value}>
            <input
              type="radio"
              {...input}
              value={o.value}
              checked={o.value === input.value}
            />
            <span style={{ paddingLeft: 5 }}>
              {o.title}
            </span>
          </label>
        ))}
        {touched && error ? (
          <Row type="flex" style={{ color: "red" }}>
            {error}
          </Row>
        ) : (
          <Row type="flex" className="input-error-label">
            &nbsp;
          </Row>
        )}
      </Row>
    </Col>
  );
};

const Checkbox = ({ input, meta: { touched, error, warning } }) => (
  <div>
    <input name="is_tbd" type="checkbox" {...input} />
    <span>
      {"   "}
      Check if unsure of dates - TBD
    </span>
    {touched && error ? (
      <div className="input-error-label">{error}</div>
    ) : (
      <div className="input-error-label">&nbsp;</div>
    )}
  </div>
);

export class NewChallengeForm extends Component {

  _createNotification = async () => {
    const { createNotification, handleSubmit } = this.props;
    const notificationResponse = await createNotification({
      challenge_id: this.props.id,
    });

    if (notificationResponse) {
      alert("Notification sent to " + notificationResponse + " users!");
      handleSubmit();
    }
  };

  _submitForm = () => {
    this.props.handleSubmit();
  }

  render() {
    const {
      challengeOpportunity,
      dateModalVisible,
      deliverables,
      formState,
      judgingCriteria,
      keyConsiderations,
      updates,
      handleSubmit,
      processEditorChange,
      searchCompanies,
      toggleDateModal,
      workEnvironment,
      results,
      companyName,
      isChallengeReadyForUpdate
    } = this.props;

    // console.log("challenge", this.props);

    return (
      <div onSubmit={handleSubmit}>
        <Row className="detail-spacer">
          <Row type="flex" justify="end">
            <Button type="primary" onClick={this._submitForm}>
              Save
            </Button>
          </Row>
          <br />
          <Row type="flex">
            <Col span={24}>
              <Row justify="center">
                <Col span={24}>
                  <Field
                    name="company_id"
                    placeholder="Company Name"
                    component={renderCompanyField}
                    searchCompanies={searchCompanies}
                    options={results}
                    companyName={companyName}
                  />
                  <Field
                    placeholder="Challenge Title"
                    name="name"
                    component={renderField}
                    type="text"
                  />
                  <Field
                    label="Functional Areas"
                    name="functional_areas"
                    component={renderMultiselect}
                    data={functional_areas}
                  />
                  <Row type="flex">
                    <Col span={6}>
                      <label>
                        <Field
                          name="challenge_type"
                          component="input"
                          type="radio"
                          value="case"
                        />
                        <span style={{ paddingLeft: 5 }}> Case Challenge </span>
                      </label>
                    </Col>
                    <Col span={6}>
                      <label>
                        <Field
                          name="challenge_type"
                          component="input"
                          type="radio"
                          value="quickfire"
                        />
                        <span style={{ paddingLeft: 5 }}>  QuickFire Challenge </span>
                      </label>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row />
              <Row />
              <Row />
              <br />
              <Row />
            </Col>
          </Row>
          <Row
            type="flex"
            justify="space-between"
            style={{ marginBottom: 40, marginTop: 40 }}
          >
            <Col span={11}>
              <Row className="challenge-header">Challenge Opportunity</Row>
              <Row>
                <Editor
                  placeholder="Write your challenge opportunity description here..."

                  editorState={challengeOpportunity}
                  wrapperClassName="editor-wrapper"
                  editorClassName="editor"
                  onEditorStateChange={editorState =>
                    processEditorChange(editorState, "challenge_opportunity")
                  }
                  toolbar={toolBarOptions}
                />
              </Row>
            </Col>
            <Col span={11}>
              <Row className="challenge-header">Key Considerations</Row>
              <Editor
                placeholder="Write your key considerations description here..."

                editorState={keyConsiderations}
                wrapperClassName="editor-wrapper"
                editorClassName="editor"
                onEditorStateChange={editorState =>
                  processEditorChange(editorState, "key_considerations")
                }
                toolbar={toolBarOptions}
              />
            </Col>
          </Row>
          <Row id="challenge-schedule-scroller">
            <Row type="flex" justify="end" style={{ padding: 15 }}>
              <Button onClick={toggleDateModal}>Modify Dates</Button>
            </Row>
            <Col span={24}>
              <Row type="flex" justify="center" >
                <div className="empty-timeline">
                  <h1
                    style={{
                      fontSize: "36px",
                      fontWeight: "bold",
                      color: "white"
                    }}
                  >
                    Deliverables Timeline
                  </h1>
                </div>
              </Row>
            </Col>
          </Row>
          <Row
            type="flex"
            justify="space-between"
            style={{ marginBottom: 40, marginTop: 40 }}
          >
            <Col span={11}>
              <Row className="challenge-header">Work Environment</Row>
              <Editor
                placeholder="Write your work environment description here..."

                editorState={workEnvironment}
                wrapperClassName="editor-wrapper"
                editorClassName="editor"
                onEditorStateChange={editorState =>
                  processEditorChange(editorState, "work_environment")
                }
                toolbar={toolBarOptions}
              />
            </Col>
            <Col span={11}>
              <Row className="challenge-header">Prizes</Row>
              <Row style={{ marginBottom: 20 }}>
                <Field
                  component={RadioGroup}
                  name="prize_type"
                  required={true}
                  options={[
                    { title: "Monetary", value: "Monetary" },
                    { title: "Non-Monetary", value: "Non-Monetary" }
                  ]}
                />
              </Row>
              <Row>
                <Field
                  placeholder="First place prize description"
                  name="first_Prize"
                  component={renderField}
                  type="text"
                />
              </Row>
              <Row>
                <Field
                  placeholder="Second place prize description"
                  name="second_prize"
                  component={renderField}
                  type="text"
                />
              </Row>
              <Row>
                <Field
                  placeholder="Third place prize description"
                  name="third_prize"
                  component={renderField}
                  type="text"
                />
              </Row>
            </Col>
          </Row>
          <Row>
            <Row className="challenge-header">Company Stakeholders</Row>
            <Col span={24}>
              <FieldArray
                name="company_stakeholders"
                component={renderStakeholders}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 100 }}>
            <Row className="challenge-header">Logistics</Row>
            <Row gutter={15}>
              <Col span={6}>
                <Field
                  label="Expected Hours"
                  name="time_commitment"
                  placeholder="Select hours"
                  component={renderSelectField}
                  options={timeCommitmentOptions}
                />
              </Col>
              <Col span={6}>
                {/* <Field
                  label="Team Size"
                  name="team_size"
                  component={renderSelectField}
                  options={teamSizeOptions}
                /> */}


                <Field
                  label="Team Size"
                  name="team_size"
                  component={renderRangeField}
                />

              </Col>
              <Col span={6}>
                <Field
                  label="Total Selected Teams"
                  name="number_of_teams"
                  component={renderSelectField}
                  options={numberOfTeamsOptions}
                />
              </Col>
              <Col span={6}>
                <Field
                  label="Travel Requirements"
                  name="travel_requirements"
                  component={renderSelectField}
                  options={travelRequirementOptions}
                />
              </Col>
            </Row>
          </Row>
          <Row style={{ marginTop: 100 }}>
            <Col span={10}>
              <Row className="challenge-header">Skills Utilized</Row>
              <Col span={24}>
                <FieldArray
                  label="skill"
                  name="skills"
                  component={renderFieldArraySelect}
                  options={skills}
                />
              </Col>
            </Col>
            <Col span={14}>
              <Row className="challenge-header">Company Engagement</Row>
              <Col span={24}>
                <FieldArray
                  label="form of engagment"
                  name="company_engagement"
                  placeholder="Company engagement description"
                  component={renderFieldArrayInput}
                />
              </Col>
            </Col>
          </Row>
          <Row style={{ marginTop: 100 }}>
            <Row className="challenge-header">Requirements</Row>
            <Col span={24}>
              <FieldArray
                label="requirment"
                name="requirements"
                placeholder="Requirement"
                horizontal={true}
                component={renderFieldArrayInput}
              />
            </Col>
          </Row>
          <Row
            type="flex"
            justify="space-between"
            style={{ marginBottom: 40, marginTop: 100 }}
          >
            <Col span={11}>
              <Row className="challenge-header">Judging Criteria</Row>
              <Row>
                <Editor
                  placeholder="Write your judging criteria here..."

                  editorState={judgingCriteria}
                  wrapperClassName="editor-wrapper"
                  editorClassName="editor"
                  onEditorStateChange={editorState =>
                    processEditorChange(editorState, "judging_criteria")
                  }
                  toolbar={toolBarOptions}
                />
              </Row>
            </Col>
            <Col span={11}>
              <Row className="challenge-header">Deliverables</Row>
              <Editor
                placeholder="Write your deliverables here..."

                editorState={deliverables}
                wrapperClassName="editor-wrapper"
                editorClassName="editor"
                onEditorStateChange={editorState =>
                  processEditorChange(editorState, "deliverables")
                }
                toolbar={toolBarOptions}
              />
            </Col>
          </Row>
          {isChallengeReadyForUpdate ?
            <Row style={{ marginTop: 100 }}>
              <Row className="challenge-header">
                Challenge Updates Editor
                <Button type="danger" style={{ marginLeft: 20 }} onClick={() => this._createNotification()}>
                  Save AND Notify Candidates of Updates
                </Button>
              </Row>
              <Col span={24}>
                <Row>
                  <Editor
                    placeholder="Write your challenge updates here..."

                    editorState={updates}
                    wrapperClassName="editor-wrapper"
                    editorClassName="editor"
                    onEditorStateChange={editorState =>
                      processEditorChange(editorState, "updates")
                    }
                    toolbar={toolBarOptions}
                  />
                </Row>
              </Col>
            </Row>
            : null}
          <Row style={{ marginTop: 100 }}>
            <Row className="challenge-header">Dependencies</Row>
            <Col span={6}>
              <Field
                label="Status"
                name="status"
                component={renderSelectField}
                options={statusOptions}
              />
            </Col>
            <Col span={6} />
            <Col span={6}>
              <div className="form-select-wrapper">
                <div>
                  <label>TypeForm ID</label>
                  <div style={{ height: 10 }} />
                </div>
              </div>
              <Field
                placeholder="Enter Form ID"
                name="typeform_form_id"
                component={renderField}
                type="text"
              />
            </Col>
          </Row>
          {formState.values &&
            formState.values.status &&
            formState.values.status === "in_progress" ? (
            <Alert
              message="Make sure all fields are filled. Otherwise, Challenge will not be viewable in Student onbaording"
              banner
            />
          ) : null}
          {formState.values &&
            formState.values.status &&
            formState.values.status === "active" ? (
            <Alert
              message="Make sure all fields are filled. Otherwise, Challenge will not be viewable in Student onbaording"
              banner
            />
          ) : null}
        </Row>

        <Modal
          title="Edit Timeline"
          closable={true}
          visible={dateModalVisible}
          onCancel={toggleDateModal}
          footer={null}
        >
          <FieldArray
            name="deliverables_timeline"
            component={renderDeliverablesTimeline}
          />

          {formState.values &&
            formState.values.is_tbd &&
            formState.values.is_tbd === true ? null : (
            <Row style={{ marginTop: 50 }}>
              <Col span={9}>
                <div className="form-select-wrapper">
                  <div>
                    <label>Start Date</label>
                    <div style={{ height: 10 }} />
                  </div>
                </div>
                <Field
                  label="Start Date"
                  name="start_date"
                  component={renderField}
                  type="date"
                />
              </Col>
              <Col span={3} />
              <Col span={9}>
                <div className="form-select-wrapper">
                  <div>
                    <label>End Date</label>
                    <div style={{ height: 10 }} />
                  </div>
                </div>
                <Field name="end_date" component={renderField} type="date" />
              </Col>
            </Row>)}

          <Row>
            <Field name="is_tbd" component={Checkbox} type="checkbox" />
          </Row>
        </Modal>
      </div>
    )
  }
}

NewChallengeForm = reduxForm({
  form: "challengeNew",
  validate
})(NewChallengeForm);

export default connect(
  state => ({
    formState: state.form.challengeNew || {}
  }),
  dispatch => ({
    createNotification: bindActionCreators(actions.createNotification, dispatch)
  })
)(NewChallengeForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/challenge/forms/new.js